export default __webpack_public_path__ + "static/media/Sell.2947ea43.svg";